var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.automatic)?_c('div',[_c('language-selector-automatic')],1):_c('div',[_c('language-selector-manual')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }